import axios from 'axios'

export const state = {
  loading: false,
}

export const getters = {
  loading(state) {
    return state.loading
  },
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}

export const actions = {
  getDeviceProductivity(
    { commit, state, rootState },
    { clearCache, deviceId, dateRange }
  ) {
    commit('SET_LOADING', true)

    // 1. Fetch the DeviceEvents from the API and cache it in case
    // we need it again in the future.
    let url =
      '/api/services/app/DeviceProductivity/GetDeviceEventsByDevice' +
      '?StartDate=' +
      dateRange.start +
      '&EndDate=' +
      dateRange.end

    if (deviceId) {
      url = url + '&DeviceId=' + deviceId
    }

    return axios
      .get(url)
      .then((response) => {
        commit('SET_LOADING', false)
        const deviceproductivity = response.data
        return deviceproductivity
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },
}
